import { render, staticRenderFns } from "./envGovDataHistory.vue?vue&type=template&id=7af447a6"
import script from "./envGovDataHistory.vue?vue&type=script&lang=js"
export * from "./envGovDataHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af447a6')) {
      api.createRecord('7af447a6', component.options)
    } else {
      api.reload('7af447a6', component.options)
    }
    module.hot.accept("./envGovDataHistory.vue?vue&type=template&id=7af447a6", function () {
      api.rerender('7af447a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/air/mst/envGovDataHistory.vue"
export default component.exports